import React from 'react'
import { app, use, api } from 'xadmin'
import { Form } from 'xadmin-form'
import { Page, C } from 'xadmin-ui'
import { message } from 'antd';
import ChangePassword from './../apps/user/pages/ChangePassword'

export default {
  title: '修改密码',
  category: '页面元素',
  icon: require('../icon/修改密码.svg'),
  component: ChangePassword,
}
